import { z } from 'zod';

// Same rules as the backend's invite DTO (`inviteTenantMemberDtoSchema`):
// trim + lower-case, valid format, at most 254 characters.
export const inviteEmailSchema = z
  .string()
  .trim()
  .toLowerCase()
  .email()
  .max(254);

// Same rules as the backend's `updateSelfDtoSchema`: trimmed, 1-100 characters.
export const memberNameSchema = z.string().trim().min(1).max(100);

export function normalizeInviteEmail(email: string): string {
  return email.trim().toLowerCase();
}

// A store must always keep at least one customer member (backend answers 409
// otherwise), so removal is only offered while someone else would remain.
export function canRemoveMember(
  members: readonly { adminUserId: string }[]
): boolean {
  return members.length >= 2;
}
